import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CodeOutlinedSvg from "@ant-design/icons-svg/es/asn/CodeOutlined";
import AntdIcon from "../components/AntdIcon";
var CodeOutlined = function CodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CodeOutlined.displayName = 'CodeOutlined';
}
export default /*#__PURE__*/React.forwardRef(CodeOutlined);